import IndustryPageTemplate from "./IndustryPageTemplate";
import { agenciesData } from "@/data/agencies";

export default function AgenciesPage() {
  return <IndustryPageTemplate data={agenciesData} />;
}
